import App from './App.vue'
export default [
    { 
      path: '/:appstate', 
      component: App,
    },
    
]